import $ from 'jquery';
import _ from 'lodash-es';

import ClassDesigner, { GRID } from '~/scripts/services/model/class-designer';
import templateModalRepre from '~/components/repre/modals/modal-repre.html';
import ModalRepreController from '~/components/repre/modals/modal-repre.controller';
import SchemaComment from '~/scripts/services/model/schema-comment';
import SchemaNode from '~/scripts/services/model/schema-node';
import jsPlumb from 'jsplumb';
import SchemaLink from '~/scripts/services/model/schema-link';
import angular from 'angular';
import DroitCust from '~/scripts/services/model/droit-cust';
import DroitDef from '~/scripts/services/model/droit-def';

export default class ClassDesignerEditorController {
	/**
	 * Référence conservée pour pouvoir désabonner dans $onDestroy.
	 *
	 * @type {?(event: KeyboardEvent) => void}
	 */
	#onKeyUp = null;

	/* @ngInject */
	/**
	 * @param {any} $copyToClipboard
	 * @param {import('angular').IRootElementService} $element
	 * @param {import('angular').IFilterService} $filter
	 * @param {import('angular').ILocationService} $location
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {import('angular').IWindowService} $window
	 * @param {any} Notification
	 */
	constructor(
		$copyToClipboard,
		$element,
		$filter,
		$location,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		$window,
		Notification,
	) {
		this.$copyToClipboard = $copyToClipboard;
		this.$element = $element;
		this.$location = $location;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.$window = $window;
		this.Notification = Notification;

		/** @type {?('droit')} */
		this.clipboard = null;
		this.ctrl = undefined;
		this.editorViewMenuOptions = [
			{
				text:  $translate.instant('designer.edit-schema'),
				click: () => this.edit(),
			},
		];

		/** @type {?ClassDesigner} */
		this.tab = null;

		this.editorEditMenuOptions = [
			{
				text:  $translate.instant('designer.add-class'),
				click: (
					/** @type {any} */ $editorScope,
					/** @type {MouseEvent} */ event,
					/** @type {any} */ tab,
				) => tab.nodeCreateFromEvent(
					event,
					'CLASS',
					'K_NODE;SYS_CLASSE',
					{
						create: true,
						isaNodeCreate: false,
						tab: 'info',
					},
				),
			},
			{
				text:  $translate.instant('designer.add-object'),
				click: (
					/** @type {any} */ $editorScope,
					/** @type {MouseEvent} */ event,
					/** @type {any} */ tab,
				) => tab.nodeCreateFromEvent(
					event,
					'OBJECT',
					'K_NODE;SYS_CLASSE',
					{
						create: true,
						isaNodeCreate: false,
						tab: 'info',
					},
				),
			},
			{
				text:  $translate.instant('designer.add-comment'),
				click: (
					/** @type {any} */ $editorScope,
					/** @type {MouseEvent} */ event,
					/** @type {any} */ tab,
				) => tab.commentCreateFromEvent(event),
			},
		];

		this.commentViewMenuOptions = [
			{
				text:  $translate.instant('common.details'),
				click: (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaComment} */ schemaComment,
				) => this.tab?.commentEdit(schemaComment, { multiple: false }),
			},
		];

		this.commentEditMenuOptions = [
			{
				text:  $translate.instant('common.modify'),
				click: (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaComment} */ schemaComment,
				) => this.tab?.commentEdit(schemaComment, { multiple: false }),
			},
			{
				text:  $translate.instant('common.delete'),
				click: (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaComment} */ schemaComment,
				) => this.tab?.commentDelete(schemaComment, true),
			},
		];

		this.nodeViewMenuOptions = [
			{
				text:  $translate.instant('common.details'),
				displayed: () => this.tab && this.tab.selected.length <= 1,
				click: (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaNode} */ schemaNode,
				) => this.tab?.nodeEdit(schemaNode, { create: false, tab: 'info' }),
			},
			{
				text:  $translate.instant('common.rights'),
				displayed: () => this.tab && this.tab.selected.length <= 1,
				click: (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaNode} */ schemaNode,
				) => this.tab?.nodeEdit(schemaNode, { create: false, tab: 'droit' }),
			},
		];

		this.nodeEditMenuOptions = [
			{
				text:  $translate.instant('common.modify'),
				displayed: () => this.tab && this.tab.selected.length <= 1,
				click: (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaNode} */ schemaNode,
				) => this.tab?.nodeEdit(schemaNode, { create: false, tab: 'info' }),
			},
			{
				text:  $translate.instant('common.rights'),
				displayed: () => this.tab && this.tab.selected.length <= 1,
				click: (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaNode} */ schemaNode,
				) => this.tab?.nodeEdit(schemaNode, { create: false, tab: 'droit' }),
			},
			{
				displayed: (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaNode} */ schemaNode,
				) => schemaNode.node?.objtype === 'CLASS' && this.tab && this.tab.selected.length <= 1,
				text:      (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaNode} */ schemaNode,
				) => $filter('sprintf')(
					$translate.instant('designer.add-object-x'), schemaNode.node?.getName() || '',
				),
				click:     (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaNode} */ schemaNode,
				) => {
					const event2 = {
						offsetX: (schemaNode.x || 0) + (GRID * 6),
						offsetY: (schemaNode.y || 0) + (GRID * 3),
					};
					return this.tab?.nodeCreateFromEvent(
						// @ts-ignore
						event2,
						'OBJECT',
						schemaNode.node.kid,
						{
							autoLinks: true,
							create: true,
							isaNodeCreate: true,
							tab: 'info',
						},
					);
				},
			},
			{
				text:  $translate.instant('designer.copy-rights'),
				displayed: () => this.tab && this.tab.selected.length <= 1,
				click: (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaNode} */ schemaNode,
				) => this.nodeCopyRights(schemaNode),
			},
			{
				text:  $translate.instant('designer.paste-rights'),
				// enabled: () => {
				// 	// navigator.clipboard.readText()
				// 	return false;
				// },
				click: (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaNode} */ schemaNode,
				) => this.nodePasteRights(schemaNode),
			},
			null,
			{
				displayed: (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaNode} */ schemaNode,
				) => schemaNode.existK && this.tab && this.tab.selected.length <= 1,
				text:  $translate.instant('common.hide'),
				click: (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaNode} */ schemaNode,
				) => this.tab?.nodeHide(schemaNode),
			},
			{
				text:  $translate.instant('common.delete'),
				click: (
					/** @type {any} */ $nodeScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaNode} */ schemaNode,
				) => this.tab?.nodeDelete(schemaNode, true),
			},
		];

		this.linkViewMenuOptions = [
			{
				text:  $translate.instant('common.details'),
				click: (
					/** @type {any} */ $linkScope,
					/** @type {MouseEvent} */ event,
					/** @type {jsPlumb.Connection} */ connection,
				) => {
					const schemaLink = this.tab?.schema?.links.find(
						(/** @type {SchemaLink} */ link) => link.getConnection()?.id === connection.id,
					);
					return schemaLink ? this.tab?.linkEdit(schemaLink, { create: false }) : null;
				},
			},
		];

		this.linkEditMenuOptions = [
			{
				text:  $translate.instant('common.modify'),
				click: (
					/** @type {any} */ $linkScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaLink} */ schemaLink,
				) => (schemaLink ? this.tab?.linkEdit(schemaLink, { create: false }) : null),
			},
			null,
			{
				text:  $translate.instant('common.delete'),
				click: (
					/** @type {any} */ $linkScope,
					/** @type {MouseEvent} */ event,
					/** @type {SchemaLink} */ schemaLink,
				) => this.tab?.linkDelete(schemaLink),
			},
		];

		$scope.$on('$viewContentLoaded', () => {
			$('html').css('overflow', 'hidden');
		});

		$scope.$on('$destroy', () => {
			$('html').css('overflow', '');
		});

		$scope.$watch('tab.schema.repre', () => {
			if (this.tab?.schema) {
				this.tab.schema.name = this.tab.schema.getName();
			}
		}, true);

		$scope.$on('angular-resizable.resizeEnd', (/** @type {Event} */ event, /** @type {any} */ arguments_) => {
			if (this.tab) {
				this.tab.panelWidth = arguments_.width;
			}
		});
	}

	$onDestroy() {
		if (this.#onKeyUp) {
			this.$window.removeEventListener('keyup', this.#onKeyUp);
			this.#onKeyUp = null;
		}
	}

	$onInit() {
		this.#onKeyUp = async (/** @type {KeyboardEvent} */ event) => {
			if (
				this.tab
				// @ts-ignore
				&& event.target?.tagName === 'BODY'
				&& event.code === 'Delete'
				&& this.tab.selected[0].node instanceof SchemaNode
			) {
				const deleted = await this.tab.nodeDelete(this.tab.selected[0].node, !event.shiftKey);
				if (deleted) {
					this.tab.unselectAll();
				}
			}
		};
		this.$window.addEventListener('keyup', this.#onKeyUp);
	}

	edit() {
		if (this.tab) {
			this.tab.edit = !this.tab.edit;
			this.tab.jsp?.setDraggable(this.$element.find('.node'), this.tab.edit);
			this.$location.search({ edit: this.tab.edit || null, kid: this.tab.schema?.kid });
		}
	}

	/**
	 * @param {SchemaComment | SchemaLink | SchemaNode} node
	 * @returns {boolean}
	 */
	isSchemaComment(node) {
		return node instanceof SchemaComment;
	}

	/**
	 * @param {SchemaComment | SchemaLink | SchemaNode} node
	 * @returns {boolean}
	 */
	isSchemaLink(node) {
		return node instanceof SchemaLink;
	}

	/**
	 * @param {SchemaComment | SchemaLink | SchemaNode} node
	 * @returns {boolean}
	 */
	isSchemaNode(node) {
		return node instanceof SchemaNode;
	}

	/**
	 * @returns {Promise<any>}
	 */
	async nodeClipboardCheck() {
		const text = await navigator.clipboard.readText();
		if (typeof text === 'string') {
			try {
				const json = JSON.parse(text);
				if (!Object.keys(json).every(k => ['droit', 'droitcust', 'droitdef'].includes(k))) {
					throw new Error('no right in clipboard');
				}
				return json;
			}
			catch {
				this.Notification.error({
					title:     this.$translate.instant('error.title'),
					message:   this.$translate.instant('error.unable-to-paste-rights'),
				});
			}
		}

		return null;
	}

	/**
	 * Copy rights to clipboard
	 *
	 * @param {SchemaNode} schemaNode
	 * @returns {*}
	 */
	nodeCopyRights(schemaNode) {
		this.$copyToClipboard(angular.toJson({
			droitcust: schemaNode.node.droitcust,
			droitdef:  schemaNode.node.droitdef,
		}));
	}

	/**
	 * @param {SchemaNode} schemaNode
	 * @returns {Promise<void>}
	 */
	async nodePasteRights(schemaNode) {
		const pasteRights = await this.nodeClipboardCheck();
		this.$timeout(() => {
			if (pasteRights && this.tab) {
				schemaNode.node.droitcust = pasteRights.droitcust?.map((/** @type {any} */ d) => new DroitCust(d));
				schemaNode.node.droitdef = pasteRights.droitdef?.map((/** @type {any} */ d) => new DroitDef(d));
				this.tab.modified = true;
			}
		});
	}

	/**
	 * Display the repre of the schema for edition
	 */
	async repreEdit() {
		try {
			const result = await this.$uibModal.open({
				ariaLabelledBy:  'modal-repre-title',
				ariaDescribedBy: 'modal-repre-body',
				template:        templateModalRepre,
				controller:      ModalRepreController,
				controllerAs:    '$ctrl',
				resolve:         {
					repre: () => this.tab?.schema?.repre,
				},
			}).result;

			if (this.tab?.schema && !_.isEqual(result.repre, this.tab?.schema?.repre)) {
				_.merge(this.tab.schema.repre, result.repre);
				this.tab.schema.name = this.tab.schema.getName(true);
				this.tab.modified = true;
			}
		}
		catch (error) {
			if (error !== 'cancel') {
				console.error(error);
			}
		}
	}

	async save() {
		return this.$timeout(() => this.tab?.save());
	}

	updateName() {
		if (this.tab?.schema) {
			this.tab.modified = true;
			this.tab.schema.setName(this.tab.schema.name || null);
		}
	}
}
